import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
	ADDITIONAL_VALIDATION_ERROR_SEPARATOR,
	IAdditionalValidationError,
	WithAdditionalValidationContext,
} from './withAdditionalValidationContext';

export const useAdditionalValidation = <ValidatedValueType = string | number | null>(
	validatedValue: ValidatedValueType,
	errorMessage: string,
	fieldName: string,
	blockId?: string,
) => {
	const {
		addAdditionalValidationError,
		removeAdditionalValidationError,
		removeAllAdditionalValidationErrorsInBlock,
		setMainFormValidationFail,
		mainFormValidationFail,
		additionalValidationErrors,
	} = useContext(WithAdditionalValidationContext);
	const { t } = useTranslation('error');

	const validationErrorId = blockId ? `${blockId}${ADDITIONAL_VALIDATION_ERROR_SEPARATOR}${fieldName}` : fieldName;

	const validationErrorMessage =
		additionalValidationErrors.find((el) => el.validationErrorId === validationErrorId)?.errorMessage || '';

	const isShowValidationError = !validatedValue && mainFormValidationFail;

	useEffect(() => {
		const error: IAdditionalValidationError = { validationErrorId, errorMessage };

		if (!validatedValue) {
			addAdditionalValidationError(error);
		} else {
			removeAdditionalValidationError(validationErrorId);
		}
	}, [validationErrorId, validatedValue]);

	useEffect(() => {
		return () => {
			removeAdditionalValidationError(validationErrorId);
		};
	}, []);

	return {
		removeAllAdditionalValidationErrorsInBlock,
		setMainFormValidationFail,
		mainFormValidationFail,
		additionalValidationErrors,
		validationErrorMessage: t(validationErrorMessage),
		isShowValidationError,
	};
};
